import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
import { Trans } from 'react-i18next';

const Navbar = () => {
  const history = useHistory();
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleOffcanvas = () => {
    document.querySelector('.sidebar-offcanvas').classList.toggle('active');
  };

  const handleLogout = () => {
    localStorage.clear();
    history.push('/auth');
  };

  const fullname = localStorage.getItem('fullname') || 'Admin';
  const role = localStorage.getItem('role') || 'Administrator';
  const initials = fullname.charAt(0).toUpperCase();

  return (
    <>
      <style>{`
        .hamsyl-navbar {
          position: fixed;
          top: 0; left: 0; right: 0;
          height: 70px;
          background: #ffffff;
          border-bottom: 1px solid #e5e7eb;
          box-shadow: 0 2px 8px rgba(0,0,0,0.06);
          display: flex;
          align-items: center;
          z-index: 1030;
          padding: 0;
        }

        /* Brand section (visible on mobile, hidden on desktop — desktop uses sidebar) */
        .hamsyl-navbar .nav-brand {
          width: 244px;
          height: 70px;
          background: linear-gradient(135deg, #0d47a1, #1565c0);
          display: none;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          text-decoration: none;
          color: #fff;
          font-weight: 700;
          font-size: 1rem;
          letter-spacing: 0.06em;
          gap: 0.4rem;
        }
        @media (max-width: 991px) {
          .hamsyl-navbar .nav-brand { display: flex; width: auto; padding: 0 1rem; }
        }

        /* Menu wrapper */
        .hamsyl-navbar .nav-body {
          flex: 1;
          display: flex;
          align-items: center;
          padding: 0 1.25rem;
          height: 100%;
          gap: 0.5rem;
        }

        /* Sidebar toggle button */
        .hamsyl-navbar .sidebar-toggle {
          background: none;
          border: none;
          width: 38px; height: 38px;
          border-radius: 8px;
          display: flex; align-items: center; justify-content: center;
          color: #6b7280;
          cursor: pointer;
          flex-shrink: 0;
          transition: background 0.15s;
        }
        .hamsyl-navbar .sidebar-toggle:hover { background: #f3f4f6; color: #111; }
        .hamsyl-navbar .sidebar-toggle .mdi { font-size: 1.4rem; }

        /* App title */
        .hamsyl-navbar .nav-title {
          font-size: 0.95rem;
          font-weight: 600;
          color: #1a1a2e;
          margin-left: 0.5rem;
          white-space: nowrap;
        }
        @media (max-width: 576px) { .hamsyl-navbar .nav-title { display: none; } }

        /* Right actions */
        .hamsyl-navbar .nav-actions {
          margin-left: auto;
          display: flex;
          align-items: center;
          gap: 0.25rem;
        }

        /* Icon button */
        .hamsyl-navbar .icon-btn {
          position: relative;
          width: 38px; height: 38px;
          border-radius: 8px;
          background: #f3f4f6;
          border: none;
          display: flex; align-items: center; justify-content: center;
          color: #374151;
          cursor: pointer;
          transition: background 0.15s;
          text-decoration: none;
        }
        .hamsyl-navbar .icon-btn:hover { background: #e5e7eb; }
        .hamsyl-navbar .icon-btn .mdi { font-size: 1.2rem; }
        .hamsyl-navbar .icon-btn .dot {
          position: absolute;
          top: 7px; right: 7px;
          width: 7px; height: 7px;
          border-radius: 50%;
          background: #ef4444;
          border: 1.5px solid #fff;
        }

        /* Profile button */
        .hamsyl-navbar .profile-btn {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.3rem 0.6rem 0.3rem 0.3rem;
          border-radius: 10px;
          border: 1px solid #e5e7eb;
          background: #f8fafc;
          cursor: pointer;
          transition: background 0.15s;
          margin-left: 0.25rem;
        }
        .hamsyl-navbar .profile-btn:hover { background: #f0f4ff; border-color: #c7d7f8; }
        .hamsyl-navbar .profile-avatar {
          width: 32px; height: 32px;
          border-radius: 50%;
          object-fit: cover;
          border: 2px solid #1a73e8;
          flex-shrink: 0;
        }
        .hamsyl-navbar .profile-text { line-height: 1.2; }
        .hamsyl-navbar .profile-name { font-size: 0.82rem; font-weight: 600; color: #1a1a2e; display: block; }
        .hamsyl-navbar .profile-role { font-size: 0.7rem; color: #6b7280; display: block; text-transform: capitalize; }
        @media (max-width: 480px) {
          .hamsyl-navbar .profile-text { display: none; }
          .hamsyl-navbar .profile-btn { padding: 0.3rem; }
        }

        /* Dropdown menu */
        .hamsyl-nav-dropdown .dropdown-menu {
          border: none !important;
          box-shadow: 0 8px 30px rgba(0,0,0,0.12) !important;
          border-radius: 12px !important;
          padding: 0.5rem !important;
          min-width: 210px;
          margin-top: 0.5rem !important;
        }
        .hamsyl-nav-dropdown .dd-header {
          display: flex;
          align-items: center;
          gap: 0.65rem;
          padding: 0.65rem 0.75rem;
          background: #f8fafc;
          border-radius: 8px;
          margin-bottom: 0.25rem;
        }
        .hamsyl-nav-dropdown .dd-header img {
          width: 38px; height: 38px;
          border-radius: 50%; object-fit: cover;
          border: 2px solid #1a73e8;
        }
        .hamsyl-nav-dropdown .dd-name { font-size: 0.875rem; font-weight: 600; color: #1a1a2e; margin: 0; }
        .hamsyl-nav-dropdown .dd-role { font-size: 0.75rem; color: #6b7280; margin: 0; text-transform: capitalize; }
        .hamsyl-nav-dropdown .dd-divider { height: 1px; background: #f0f0f0; margin: 0.25rem 0; }
        .hamsyl-nav-dropdown .dd-item {
          display: flex !important;
          align-items: center;
          gap: 0.6rem;
          padding: 0.55rem 0.75rem !important;
          border-radius: 8px !important;
          font-size: 0.875rem;
          color: #374151 !important;
          transition: background 0.15s !important;
        }
        .hamsyl-nav-dropdown .dd-item:hover { background: #f3f4f6 !important; }
        .hamsyl-nav-dropdown .dd-item.danger { color: #ef4444 !important; }
        .hamsyl-nav-dropdown .dd-item.danger:hover { background: #fef2f2 !important; }
        .hamsyl-nav-dropdown .dd-item .mdi { font-size: 1.1rem; color: #6b7280; }
        .hamsyl-nav-dropdown .dd-item.danger .mdi { color: #ef4444; }

        /* Mobile offcanvas toggle (right side) */
        .hamsyl-navbar .offcanvas-toggle {
          display: none;
          background: none;
          border: none;
          width: 38px; height: 38px;
          border-radius: 8px;
          align-items: center; justify-content: center;
          color: #6b7280; cursor: pointer;
          transition: background 0.15s;
        }
        .hamsyl-navbar .offcanvas-toggle:hover { background: #f3f4f6; }
        .hamsyl-navbar .offcanvas-toggle .mdi { font-size: 1.3rem; }
        @media (max-width: 991px) { .hamsyl-navbar .offcanvas-toggle { display: flex; } }
      `}</style>

      <nav className="hamsyl-navbar">
        {/* Mobile brand */}
        <Link className="nav-brand" to="/">
          <span>✈</span> HAMSYL
        </Link>

        <div className="nav-body">
          {/* Sidebar collapse toggle (desktop) */}
          <button
            className="sidebar-toggle d-none d-lg-flex"
            onClick={() => document.body.classList.toggle('sidebar-icon-only')}
          >
            <span className="mdi mdi-menu" />
          </button>

          <span className="nav-title d-none d-lg-block">✈ Hamsyl Travel &amp; Tours</span>

          <div className="nav-actions">
            {/* Notifications */}
            <button
              className="icon-btn"
              onClick={() => history.push('/notification/notification-list')}
              title="Notifications"
            >
              <span className="mdi mdi-bell-outline" />
              <span className="dot" />
            </button>

            {/* Profile dropdown */}
            <Dropdown alignRight className="hamsyl-nav-dropdown">
              <Dropdown.Toggle as="div" className="profile-btn" bsPrefix="no-caret">
                <div
                  className="profile-avatar"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'linear-gradient(135deg, #1a73e8, #0d47a1)',
                    color: '#fff',
                    fontWeight: 700,
                    fontSize: '0.85rem',
                    border: '2px solid #1a73e8'
                  }}
                >
                  {initials}
                </div>
                <div className="profile-text">
                  <span className="profile-name">{fullname}</span>
                  <span className="profile-role">{role}</span>
                </div>
                <span className="mdi mdi-chevron-down" style={{ color: '#9ca3af', fontSize: '1rem', marginLeft: '2px' }} />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <div className="dd-header">
                  <div
                    style={{
                      width: 38,
                      height: 38,
                      borderRadius: '50%',
                      background: 'linear-gradient(135deg, #1a73e8, #0d47a1)',
                      color: '#fff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontWeight: 700,
                      border: '2px solid #1a73e8'
                    }}
                  >
                    {initials}
                  </div>
                  <div>
                    <p className="dd-name">{fullname}</p>
                    <p className="dd-role">{role}</p>
                  </div>
                </div>
                <div className="dd-divider" />
                <Dropdown.Item
                  className="dd-item"
                  onClick={() => history.push('/auth/new/user/role')}
                >
                  <span className="mdi mdi-cog-outline" />
                  <Trans>Settings</Trans>
                </Dropdown.Item>
                <div className="dd-divider" />
                <Dropdown.Item className="dd-item danger" onClick={handleLogout}>
                  <span className="mdi mdi-logout" />
                  Log Out
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            {/* Mobile offcanvas toggle */}
            <button className="offcanvas-toggle" onClick={toggleOffcanvas}>
              <span className="mdi mdi-format-line-spacing" />
            </button>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
